// pages/NotificationDetailsPage.js
import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Layout from "../../components/Layout";
import PageTitle from "../../components/PageTitle";
import { httprequest } from "../../data/api";
import { toast } from "react-toastify";
import { Box } from "@mui/material";
import { Icon } from "@iconify/react";
import useStyles from "./styles";
import logo from "../../assets/images/shelflogo.png";
import PageLoader from "../../components/PageLoader";

const NOTIFICATIONS_ENDPOINT = "/api/v1/notifications";

const getInitials = (name) => {
  if (!name) return "S";
  const parts = name.split(" ");
  if (parts.length > 1) {
    return parts[0][0] + parts[1][0];
  }

  return parts[0].substring(0, 2);
};

const formatDateTime = (isoString) => {
  const date = new Date(isoString);

  return date.toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false
  });
};

const parseMessageContent = (message) => {
  try {
    const parsed = JSON.parse(message);

    return {
      title: parsed.title || "Notification",
      body: parsed.body || message
    };
  } catch (error) {
    return {
      title: "Notification",
      body: message
    };
  }
};

const NotificationDetailsPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const classes = useStyles();
  const [notification, setNotification] = useState(null);
  const [loading, setLoading] = useState(true);

  const getNotification = async () => {
    try {
      setLoading(true);

      const [notificationRes] = await Promise.all([
        httprequest.get(`${NOTIFICATIONS_ENDPOINT}/${id}`),
        httprequest.patch(`${NOTIFICATIONS_ENDPOINT}/${id}`, { read: true })
      ]);

      setNotification(notificationRes?.data?.data);
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to fetch notification details");
    } finally {
      setLoading(false);
    }
  };

  const handleBackClick = () => {
    navigate("/notifications");
  };

  useEffect(() => {
    if (id) {
      getNotification();
    }
  }, [id]);

  if (loading) {
    return (
      <Layout>
        <PageTitle
          title="Notification"
          subtitle="See every information that comes to your desk. Never miss an alert."
        />
        <div className="page-content">
          <div style={{ padding: "40px", textAlign: "center" }}><PageLoader /></div>
        </div>
      </Layout>
    );
  }

  const messageContent = parseMessageContent(notification.message);
  const displayTitle = notification.title || messageContent.title;
  const displayBody = messageContent.body;

  return (
    <Layout>
      <PageTitle
        title="Notification"
        subtitle="See every information that comes to your desk. Never miss an alert."
      />

      <div className="page-content white_bg white-bg">
        <Box className={classes.detailBody}>
          <Box className={classes.rightPanelHeaderMobile}>
            <Box className={classes.backButton} onClick={handleBackClick}>
              <Icon icon="mdi:arrow-left" />
              <span>Back to Notifications</span>
            </Box>
          </Box>

          <div className={classes.notifHeaderContainer}>
            <div className={classes.notifleft}>
              <div className={classes.notifAvatar}>
                {getInitials("Shelf21")}
              </div>
              <div className={classes.notifUserInfo}>
                <div className={classes.notifFrom}>Shelf21</div>
                <div className={classes.notifTo}>To: You</div>
              </div>
            </div>
            <div className={classes.notifDate}>
              {formatDateTime(notification.created_at)}
            </div>
          </div>

          <div className={classes.detailBodySubject}>
            <h2>{displayTitle}</h2>
            <img src={logo} className={classes.subjectimage} alt="Shelf21 Logo" />
          </div>

          <Box
            className={classes.detailBodyContent}
            dangerouslySetInnerHTML={{ __html: displayBody.replace(/\n/g, "<br />") }}
          />

          <div className={classes.securitySection}>
            <div>
              If you see any suspicious activity on your account, please{" "}
              <span className={classes.securityLink}>
                contact us via our support site
              </span>.
            </div>
            <div className={classes.teamSignature}>
              - The shelf21 team
            </div>
          </div>

          <Box className={classes.detailFooter}>
            <Box className={classes.detailFooterText}>
              Shelf21 - 17b Somewhere in Lagos, Nigeria.
            </Box>
            <Box className={classes.socialIconsWrapper}>
              <div className={classes.socialWrapper}>
                <Icon icon="mdi:instagram" className={classes.socialIcon} />
              </div>
              <div className={classes.socialWrapper}>
                <Icon icon="uil:facebook-f" className={classes.socialIcon} />
              </div>
              <div className={classes.socialWrapper}>
                <Icon icon="mdi:twitter" className={classes.socialIcon} />
              </div>
            </Box>
          </Box>
        </Box>
      </div>
      {/* <ToastContainer /> */}
    </Layout>
  );
};

export default NotificationDetailsPage;
